(function () {
  'use strict';

  if (typeof Vue === 'undefined') {
    console.warn('[slideout-cart] Vue 2 is not loaded.');
    return;
  }

  // Intercept ALL fetch calls to /cart/add.js globally, regardless of source
  var _nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var method = (init && init.method || 'GET').toUpperCase();
    var isCartAdd = url.indexOf('/cart/add') !== -1 && method === 'POST';
    var promise = _nativeFetch.apply(this, arguments);
    if (isCartAdd) {
      promise.then(function (res) {
        if (res.ok) {
          var clone = res.clone();
          clone.json().then(function (addedItem) {
            document.dispatchEvent(new CustomEvent('slideout-cart:item-added', { detail: { item: addedItem } }));
          }).catch(function () {
            document.dispatchEvent(new CustomEvent('slideout-cart:item-added'));
          });
        }
        return res;
      });
    }
    return promise;
  };

  // Also intercept jQuery $.ajax if jQuery is present
  if (window.jQuery) {
    jQuery(document).ajaxSuccess(function (event, xhr, settings) {
      if (settings.url && settings.url.indexOf('/cart/add') !== -1 &&
          (settings.type || '').toUpperCase() === 'POST') {
        var addedItem = null;
        try { addedItem = JSON.parse(xhr.responseText); } catch (e) {}
        document.dispatchEvent(new CustomEvent('slideout-cart:item-added', { detail: { item: addedItem } }));
      }
    });
  }

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat || '${{amount}}');
    }
    return '$' + (cents / 100).toFixed(2);
  }

  var SlideoutCart = {
    el: '#slideout-cart-app',
    delimiters: ['[[', ']]'],

    data: function () {
      var insuranceEl = document.querySelector('[data-insurance-variant-id]');
      return {
        open: false,
        loading: false,
        loaded: false,
        updatingKey: null,
        insuranceVariantId: insuranceEl ? insuranceEl.dataset.insuranceVariantId : null,
        insuranceTitle: insuranceEl ? insuranceEl.dataset.insuranceTitle : '',
        insurancePrice: insuranceEl ? insuranceEl.dataset.insurancePrice : '',
        insuranceUpdating: false,
        cart: {
          items: [],
          total_price: 0,
          item_count: 0
        }
      };
    },

    computed: {
      cartTotal: function () {
        // Derive total from cart.items so Vue always re-evaluates this when
        // items change — avoids stale cache when cart object is replaced async
        return this.cart.items.reduce(function (sum, i) {
          return sum + (i.final_line_price || 0);
        }, 0);
      },

      subtotal: function () {
        return formatMoney(this.cartTotal);
      },

      shippingThreshold: function () {
        return 15000; // $150.00 in cents
      },

      shippingAmountLeft: function () {
        return Math.max(0, this.shippingThreshold - this.cartTotal);
      },

      shippingAmountLeftFormatted: function () {
        return formatMoney(this.shippingAmountLeft);
      },

      shippingProgress: function () {
        return Math.min(100, Math.round((this.cartTotal / this.shippingThreshold) * 100));
      },

      insuranceInCart: function () {
        var id = this.insuranceVariantId;
        if (!id) return false;
        return this.cart.items.some(function (item) {
          return String(item.variant_id) === String(id);
        });
      }
    },

    methods: {
      openCart: function () {
        if (!this.loaded) this.fetchCart();
        this.open = true;
        document.body.style.overflow = 'hidden';
      },

      closeCart: function () {
        this.open = false;
        document.body.style.overflow = '';
      },

      fetchCart: function (silent) {
        var self = this;
        if (!silent) self.loading = true;
        fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (res) { return res.json(); })
          .then(function (data) {
            self.cart = data;
            self.loading = false;
            self.loaded = true;
          })
          .catch(function () { self.loading = false; });
      },

      updateQuantity: function (key, newQty) {
        var self = this;
        self.updatingKey = key;
        fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: newQty })
        })
          .then(function (res) { return res.json(); })
          .then(function (data) {
            self.cart = data;
            self.updatingKey = null;
            self._syncHeaderCount(data.item_count);
          })
          .catch(function () { self.updatingKey = null; });
      },

      removeItem: function (key) {
        this.updateQuantity(key, 0);
      },

      increment: function (item) {
        this.updateQuantity(item.key, item.quantity + 1);
      },

      decrement: function (item) {
        if (item.quantity <= 1) {
          this.removeItem(item.key);
        } else {
          this.updateQuantity(item.key, item.quantity - 1);
        }
      },

      itemPrice: function (item) {
        return formatMoney(item.final_line_price);
      },

      itemImage: function (item) {
        if (!item.image) return 'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-product-1_large.png';
        return item.image.replace(/(\.[a-z]+)(\?|$)/, '_120x120$1$2');
      },

      injectItem: function (addedItem) {
        // /cart/add.js returns a single item or { items: [...] } for multi-add
        var newItems = addedItem.items || [addedItem];
        var cart = this.cart;
        newItems.forEach(function (newItem) {
          var existing = cart.items.find(function (i) { return i.key === newItem.key; });
          if (existing) {
            existing.quantity = newItem.quantity;
            existing.final_line_price = newItem.final_line_price;
          } else {
            cart.items.unshift(newItem);
          }
        });
        // Recalculate totals optimistically
        cart.item_count = cart.items.reduce(function (sum, i) { return sum + i.quantity; }, 0);
        cart.total_price = cart.items.reduce(function (sum, i) { return sum + i.final_line_price; }, 0);
        this._syncHeaderCount(cart.item_count);
        this.loaded = true;
      },

      toggleInsurance: function () {
        var self = this;
        if (!self.insuranceVariantId || self.insuranceUpdating) return;
        self.insuranceUpdating = true;
        var adding = !self.insuranceInCart;
        var promise;
        if (adding) {
          promise = fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: self.insuranceVariantId, quantity: 1 }] })
          });
        } else {
          promise = fetch('/cart/change.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: self.insuranceVariantId, quantity: 0 })
          });
        }
        promise
          .then(function (res) { return res.json(); })
          .then(function () {
            self.fetchCart(true);
            self.insuranceUpdating = false;
          })
          .catch(function () { self.insuranceUpdating = false; });
      },

      _syncHeaderCount: function (count) {
        // Update all known badge selectors used across the theme
        var selectors = [
          '.cart-qty',
          '.header-cart .badge',
          '.header-cart .title_count',
          '.header-cart-sticky-holder .badge'
        ];
        document.querySelectorAll(selectors.join(',')).forEach(function (el) {
          el.textContent = count;
        });
        // Also toggle the header-cart-empty class used for styling
        var cartHolder = document.querySelector('.header-cart-holder');
        if (cartHolder) {
          count > 0
            ? cartHolder.classList.remove('header-cart-empty')
            : cartHolder.classList.add('header-cart-empty');
        }
      }
    },

    mounted: function () {
      var self = this;

      // Pre-fetch cart silently on page load so data is ready before user opens
      self.fetchCart(true);

      // Listen for custom event to open cart
      document.addEventListener('slideout-cart:open', function () {
        self.openCart();
      });

      // Fired by the global fetch interceptor on any successful /cart/add.js call
      document.addEventListener('slideout-cart:item-added', function (e) {
        var addedItem = e.detail && e.detail.item;
        if (addedItem) {
          self.injectItem(addedItem);
        }
        self.open = true;
        document.body.style.overflow = 'hidden';
        // Background sync to get accurate totals/discounts
        self.fetchCart(true);
      });


      // Keyboard: close on Escape
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.open) self.closeCart();
      });

      // Header cart button — open slideout, suppress native minicart (desktop hover + mobile click)
      document.addEventListener('click', function (e) {
        var trigger = e.target.closest('.header-cart');
        if (trigger) {
          e.preventDefault();
          e.stopPropagation();
          self.openCart();
        }
      });

      // Strip mobile minicart jQuery handlers from both the main and sticky cart holders.
      function stripMinicartHandlers() {
        jQuery('.header-cart-holder, .header-cart-sticky-holder').each(function () {
          jQuery('> a', this).off('click.mobileMinicart');
          jQuery(this).off('.mobileMinicart');
        });
      }

      if (window.jQuery) {
        setTimeout(stripMinicartHandlers, 0);

        // Re-strip whenever the sticky bar moves elements around (scroll / resize)
        jQuery(window).on('scroll.slideoutCart resize.slideoutCart', function () {
          stripMinicartHandlers();
        });
      }

      // Intercept add-to-cart form submissions so the page never redirects to /cart
      document.addEventListener('submit', function (e) {
        var form = e.target;
        if (!form || form.action.indexOf('/cart/add') === -1) return;
        e.preventDefault();

        var btn = form.querySelector('.js-add-to-cart, .js-add-to-cart-product-page, [type="submit"]');
        if (btn) {
          btn.classList.add('btn-loading', 'disabled');
          btn.innerHTML = '<i class="icon icon-spinner3 spin"></i><span>' + (window.locales && locales.adding ? locales.adding : 'Adding...') + '</span>';
        }

        var formData = new FormData(form);
        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json' },
          body: formData
        })
          .then(function (res) { return res.json(); })
          .then(function (data) {
            if (btn) {
              btn.classList.remove('btn-loading', 'disabled');
              btn.innerHTML = '<span>' + (btn.getAttribute('title') || 'Add to Cart') + '</span>';
            }
          })
          .catch(function () {
            if (btn) {
              btn.classList.remove('btn-loading', 'disabled');
              btn.innerHTML = '<span>' + (btn.getAttribute('title') || 'Add to Cart') + '</span>';
            }
          });
      }, true);
    }
  };

  document.addEventListener('DOMContentLoaded', function () {
    if (document.getElementById('slideout-cart-app') && window.location.pathname !== '/cart') {
      new Vue(SlideoutCart);
    }
  });

  // Expose helper so other scripts can open the cart
  window.slideoutCart = {
    open: function () {
      document.dispatchEvent(new CustomEvent('slideout-cart:open'));
    }
  };
})();
